export default "<ion-app>\n  <ion-router-outlet id=\"principal\"></ion-router-outlet>\n</ion-app>\n"